module.exports = __webpack_public_path__ + "img/03_BC3_become_home_alone.b43e88aa.jpg";